import { useLocation } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";
import { AdminHeader } from "./AdminHeader";

const pageMeta: Record<string, { title: string; description: string }> = {
  "/admin/users":       { title: "Patients",    description: "All patients registered through the MedSyncIQ patient portal" },
  "/admin/audit-trail": { title: "Audit Trail", description: "Every upload, login, and clinical-record activity across MedSyncIQ" },
};

export function AdminLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const meta = pageMeta[location.pathname];

  return (
    <div className="flex h-screen overflow-hidden bg-[#F7F7F7]">
      <AdminSidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <AdminHeader title={meta?.title} description={meta?.description} />
        <main id="admin-content" className="msq-route-main flex-1 overflow-y-auto bg-[#F7F7F7]">
          {children}
        </main>
      </div>
    </div>
  );
}
